import type { ReactNode } from 'react';
import type { ContentType, ValueElementIdReferenceAPI } from '../../../../../../../../types/value';
import FormGroup from '../../../../../../../generic/FormGroup';
import InputOrValuePicker from '../../../../../../../generic/InputOrValuePicker';
import { isNullOrEmpty } from '../../../../../../../../utils/guard';

type ValuePickerWrapperProps = {
    id: string;
    label: string;
    isRequired?: boolean;
    testId: string;
    value: string | ValueElementIdReferenceAPI | undefined;
    container: HTMLElement | null;
    description?: string | undefined;
    children?: ReactNode;
    onChangeAsValueReference: (value: string | ValueElementIdReferenceAPI | null) => void;
    contentType?: ContentType;
    validationMessage?: string | undefined;
};

const ValuePickerWrapper = ({
    id,
    label,
    isRequired = false,
    testId,
    value,
    container,
    description,
    contentType = 'ContentString',
    children,
    onChangeAsValueReference,
    validationMessage,
}: ValuePickerWrapperProps) => {
    return (
        <FormGroup
            label={label}
            htmlFor={id}
            isRequired={isRequired}
            testId={testId}
            isValid={!isNullOrEmpty(value)}
            validationMessage={validationMessage || ''}
            showValidation={isRequired}
        >
            <InputOrValuePicker
                value={value ?? null}
                onChangeAsValueReference={onChangeAsValueReference}
                contentType={contentType}
                includeSystemValues={false}
                container={container}
            >
                {children}
            </InputOrValuePicker>
            {description && <p className="quiet ex-mt-2x-small">{description}</p>}
        </FormGroup>
    );
};

export default ValuePickerWrapper;
